module.exports = __webpack_public_path__ + "static/media/phone-volume.630ebbe3.svg";